import React from "react";
import { Tooltip } from "@mui/material";
import styled from "styled-components";
import { ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";
import { AttentionIcon } from "../../../CommonUI/Icon/AttentionIcon";

interface IError {
    issues: ValidationIssue[];
}

export const Error = ({ issues }: IError) => {
    if (issues.length === 0) return null;

    return (
        <Tooltip title={issues[0].issue}>
            <ErrorRender id={issues[0].elementId}>
                <AttentionIcon />
            </ErrorRender>
        </Tooltip>
    );
};

export const ErrorRender = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 24px;

    z-index: 1;
`;
